import reducers from './reducers';

// Named exports for types, selectors, and operations
export { default as searchTypes } from './types';
export { default as searchSelectors } from './selectors';
export { default as searchOperations } from './operations';

// Default export is the reducers
export default reducers;
